import React, { RefObject } from "react";
import { Plan, PlanDetailsPageSection } from "../../../@types";
import { PlanDetailSection } from "../components";
import { useTranslate } from "../../../helpers";
import { Premiums } from "./Premiums";
import { Deductibles } from "./Deductibles";
import { EstimatedYearlyCosts } from "./EstimatedYearlyCosts";
import { OopcMaximum } from "./OopcMaximum";
import { ContactInformation } from "./ContactInformation";

const OverviewSection: React.FunctionComponent<{
  plan: Plan;
  sectionRef: RefObject<HTMLDivElement>;
}> = ({ plan, sectionRef }) => {
  const t = useTranslate();
  return (
    <PlanDetailSection
      id={PlanDetailsPageSection.OVERVIEW}
      title={t("plan_details.overview")}
      sectionRef={sectionRef}
    >
      <Premiums plan={plan} />
      <Deductibles plan={plan} />
      <EstimatedYearlyCosts plan={plan} />
      <OopcMaximum plan={plan} />
      <ContactInformation plan={plan} />
    </PlanDetailSection>
  );
};

export { OverviewSection };
